import { Reveal, MaskText, Stagger, StaggerItem } from "./Reveal";

const CHANGES = [
  "You learn something about your customer.",
  "A product takes off that you didn't expect.",
  "The thing you thought would work doesn't.",
  "You hire.",
  "You lose someone.",
  "Cash gets tight.",
  "A huge opportunity appears.",
  "You enter a new market.",
  "You realize you're spending all your time solving the wrong problem.",
];

export const Problem = () => (
  <section id="problem" className="relative bg-cream py-24 sm:py-32">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-y-12 gap-x-8">
        <div className="lg:col-span-7">
          <Reveal>
            <span className="font-sans text-xs uppercase tracking-[0.28em] text-cognac">The Problem</span>
          </Reveal>
          <h2 className="mt-6 font-serif text-ocean leading-[0.98] tracking-[-0.02em] text-4xl sm:text-5xl lg:text-[4.2rem]">
            <MaskText lines={["Your business changed.", <span key="p" className="italic text-cognac">Why hasn't your plan?</span>]} />
          </h2>
          <div className="mt-9 max-w-xl font-sans text-base sm:text-lg text-ink/75 leading-relaxed space-y-5">
            <Reveal delay={0.1}>
              <p>
                Most business plans are outdated almost as soon as they're written.{" "}
                <span className="text-ocean font-medium">Because businesses don't grow in straight lines.</span>
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p>
                And suddenly the roadmap you started with no longer matches the business you're
                actually running.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="font-serif italic text-2xl text-ocean leading-snug">
                That doesn't necessarily mean something went wrong. It may simply mean your
                business grew up.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-5 lg:pl-10 lg:border-l border-[var(--line)]">
          <Stagger className="space-y-3" amount={0.07}>
            {CHANGES.map((c, i) => (
              <StaggerItem key={c}>
                <p className="flex items-baseline gap-4 font-serif text-lg sm:text-xl text-ink/70 leading-snug">
                  <span className="font-sans text-[10px] tracking-[0.2em] text-cognac/70 shrink-0 w-6">{String(i + 1).padStart(2, "0")}</span>
                  {c}
                </p>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </div>

      <Reveal delay={0.1}>
        <blockquote className="mt-24 sm:mt-32 font-serif text-ocean tracking-[-0.02em] leading-[1.02] text-3xl sm:text-5xl lg:text-[3.8rem] max-w-5xl">
          You don't need to predict the entire journey.
          <span className="block italic text-cognac mt-2">You need to know what this stage requires from you.</span>
        </blockquote>
      </Reveal>
    </div>
  </section>
);
